"use strict";var e=require("./index-flGcVSBB.js");module.exports=e.toRem;
